import { render, staticRenderFns } from "./agreement-dialog.vue?vue&type=template&id=c52d29fa&scoped=true"
import script from "./agreement-dialog.vue?vue&type=script&lang=js"
export * from "./agreement-dialog.vue?vue&type=script&lang=js"
import style0 from "./agreement-dialog.vue?vue&type=style&index=0&id=c52d29fa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c52d29fa",
  null
  
)

export default component.exports